import { Flex } from '@primitives/Layout'
import { Text } from 'mds-web-ui'
import React from 'react'

const PLATFORM_ORDER = ['ios', 'ipados', 'macos', 'watchos', 'web']

const PLATFORM_LABELS = {
  ios: 'iOS',
  ipados: 'iPadOS',
  macos: 'macOS',
  watchos: 'watchOS',
  web: 'Web'
}

const formatPlatforms = platforms => {
  if (!platforms?.length) {
    return null
  }

  return [...platforms]
    .sort((a, b) => PLATFORM_ORDER.indexOf(a) - PLATFORM_ORDER.indexOf(b))
    .map(platform => PLATFORM_LABELS[platform] || platform)
    .join(', ')
}

export const ArticleMeta = ({ platforms, updatedFormatted }) => {
  const appliesTo = formatPlatforms(platforms)
  const parts = []

  if (appliesTo) {
    parts.push(`Applies to: ${appliesTo}`)
  }

  if (updatedFormatted) {
    parts.push(`Updated ${updatedFormatted}`)
  }

  if (!parts.length) {
    return null
  }

  return (
    <Flex as="p" m={0} pb={2} gap={1} flexWrap="wrap" alignItems="baseline">
      {parts.map((part, index) => (
        <React.Fragment key={part}>
          {index > 0 ? (
            <Text fontSize={1} color="#585859" opacity={0.5} aria-hidden>
              ·
            </Text>
          ) : null}
          <Text fontSize={1} color="#585859" opacity={0.75}>
            {part}
          </Text>
        </React.Fragment>
      ))}
    </Flex>
  )
}
